import { FC } from 'react';
import { capitalize, Chip } from '@mui/material';

interface CampaignAdGroupStatusProps {
    value: string | null | undefined;
}

const CampaignAdGroupStatus: FC<CampaignAdGroupStatusProps> = ({ value }) => {
    let color: 'success' | 'warning' | 'error' | 'default';

    switch (value) {
        case 'ACTIVE':
            color = 'success';
            break;

        case 'INACTIVE':
            color = 'error';
            break;

        default:
            color = 'default';
            break;
    }
    return (
        <>
            <Chip
                size="small"
                label={capitalize(value?.toLowerCase() ?? '')}
                variant="filled"
                sx={{
                    fontWeight: (theme) => theme.typography.fontWeightMedium,
                }}
                color={color}
            />
        </>
    );
};

export type { CampaignAdGroupStatusProps };
export default CampaignAdGroupStatus;
